import ParkpassToR1SPassConverter from "../helpers/ParkpassToR1SPassConverter";

//Builds R1S Order objects from flattened park pass/order objects
export default class ParkOrderToR1SOrderConverter {
  convert(order) {
    //Parkpass pass object is flat key value pairs.  Need to form R1S structure
    let r1sOrder = {
      receipt_email: order.orderDetails.deliveryEmail,
      inventory: {
        parkpass: []
      }
    };

    let converter = new ParkpassToR1SPassConverter();
    order.passes.forEach(pass => {
      let r1spass = converter.convert(pass);
      r1sOrder.inventory.parkpass.push(r1spass);
    });

    return r1sOrder;
  }
}
